// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dialog__body[data-v-114f4f50] {\n  padding: 15px 20px;\n}\n.el-link[data-v-114f4f50] {\n  font-size: 20px;\n}\n.el-link.el-link--success[data-v-114f4f50] {\n  color: #30b08f;\n}\n.text[data-v-114f4f50] {\n  font-size: 20px;\n}", ""]);
// Exports
module.exports = exports;
